import AddressCascader from './address-cascader'

export default {
    install: function(Vue) {
        Vue.component('AddressCascader', AddressCascader)
    }
}